// extracted by mini-css-extract-plugin
module.exports = {"App":"App_App__1IQbR","AppLogo":"App_AppLogo__3Yi7f","App-logo-spin":"App_App-logo-spin__29Xq1","AppHeader":"App_AppHeader__2IzuF","AppLink":"App_AppLink__18Yfv"};